import { buttonClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { premiumColor } from 'uiKit/Theme/themeUtils';

const name = 'GetPremiumButton';

export const useGetPremiumButtonStyles = makeStyles({ name })(() => ({
  root: {
    width: 'fit-content',
    background: premiumColor,

    '&:focus, &:active': {
      boxShadow: 'none',
    },

    [`&.${buttonClasses.fullWidth}`]: {
      width: '100%',
    },
  },
}));
